
  var selectCallback = function(variant, selector) {
    timber.productPage({
      money_format: "",
      variant: variant,
      selector: selector,
      translations: {
        add_to_cart : "BUY NOW",
        sold_out : "Sold Out",
        unavailable : "Unavailable"
      }
    });
  };

  jQuery(function($) {
    new Shopify.OptionSelectors('productSelect', {
      product: null,
      onVariantSelected: selectCallback,
      enableHistoryState: true
    });

    // Add label if only one product option and it isn't 'Title'. Could be 'Size'.
    

    // Hide selectors if we only have 1 variant and its title contains 'Default'.
    
  });